import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { ExpandCollapse, Typography } from '@telus-uds/components-web';

import request from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { FilterGridContainer } from './css';
import { getFormattedPayload, initialFiltersValue } from '../utils';

import FilterBySalesManager from './components/filterBySalesManager';
import FilterByChannel from './components/filterByChannel';
import FilterByDealership from './components/filterByDealership';
import FilterByOutlet from './components/filterByOutlet';
import ActionButtons from './components/actionButtons';
import FilterByChannelOrgCode from './components/filterByChannelOrgCode';
import FilterByAccountStatus from './components/filterByAccountStatus';

const Filters = ({ filters, setFilters, setUsers }) => {
  const { search } = useLocation();
  const { page } = queryString.parse(search);
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filtersDropdownTitle }
  } = localizedStrings;

  const onApplyFilters = async (resetFilters = false) => {
    let payload = getFormattedPayload(filters);

    if (resetFilters) {
      setFilters(initialFiltersValue);
      payload = {
        ...payload,
        ...initialFiltersValue
      };
    }

    try {
      const response = await request.post('/users/filter', {
        ...payload,
        page: page || 1
      });

      if (response) {
        const {
          data: { users, count }
        } = response;
        const updatedUserData = users.map(user => ({
          ...user,
          role_description: _.get(user, 'role.description', 'Sales Rep')
        }));
        setUsers({ data: updatedUserData, count });
      }
    } catch (err) {
      throw err;
    }
  };

  return (
    <ExpandCollapse initialOpen={[]}>
      {(expandProps) => (
        <ExpandCollapse.Panel
          {...expandProps}
          panelId="filters"
          control={<Typography variant={{ bold: true }}>{filtersDropdownTitle}</Typography>}
        >
          <FilterGridContainer>
            <FilterBySalesManager filters={filters} setFilters={setFilters} />
            <FilterByChannel filters={filters} setFilters={setFilters} />
            <FilterByDealership filters={filters} setFilters={setFilters} />
            <FilterByOutlet filters={filters} setFilters={setFilters} />
            <FilterByChannelOrgCode filters={filters} setFilters={setFilters} />
            <FilterByAccountStatus filters={filters} setFilters={setFilters} />
            <ActionButtons onApplyFilters={onApplyFilters} />
          </FilterGridContainer>
        </ExpandCollapse.Panel>
      )}
    </ExpandCollapse>
  );
};

Filters.propTypes = {
  filters: PropTypes.shape({
    salesManager: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    ),
    channel: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    ),
    dealership: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    ),
    outletId: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    ),
    channelOrgCode: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    ),
    accountStatus: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    )
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  setUsers: PropTypes.func.isRequired
};

export default Filters;
